import { userApi, statisticsApi } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

export const userApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserById: builder.query({
      query: ({ id }) => ({
        url: userApi(),
        method: 'POST',
        body: {
          data: { id },
          method: 'findById'
        }
      }),
      providesTags: (result, error, { id }) => [{ type: 'User', id }],
      transformResponse: (response) => {
        if (response && response.data) {
          return response.data;
        }
        return response;
      }
    }),

    getUserStatistics: builder.query({
      query: ({ userId }) => ({
        url: statisticsApi(),
        method: 'POST',
        body: {
          data: { userId },
          method: 'user'
        }
      }),
      providesTags: (result, error, { userId }) => [{ type: 'UserStatistics', id: userId }],
      transformResponse: (response) => {
        if (response && response.data && response.data.courses) {
          return response.data.courses;
        }
        if (response && response.courses) {
          return response.courses;
        }
        return [];
      }
    }),

    updateUserRoles: builder.mutation({
      query: ({ id, roles }) => ({
        url: userApi(),
        method: 'POST',
        body: {
          data: { roles, id },
          method: 'update'
        }
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'User', id }],
    }),

    setUserRoleInGroup: builder.mutation({
      query: ({ userId, circleId, role }) => ({
        url: userApi(),
        method: 'POST',
        body: {
          data: { userId, circleId, role },
          method: 'setCircleRole'
        }
      }),
      invalidatesTags: (result, error, { circleId }) => [{ type: 'GroupUsers', id: circleId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUserByIdQuery,
  useGetUserStatisticsQuery,
  useUpdateUserRolesMutation,
  useSetUserRoleInGroupMutation,
} = userApiSlice;
